import App from '@react/react-spectrum/Icon/App';
import ArticleIcon from '@react/react-spectrum/Icon/Article';
import BranchCircle from '@react/react-spectrum/Icon/BranchCircle';
import Campaign from '@react/react-spectrum/Icon/Campaign';
import Collection from '@react/react-spectrum/Icon/Collection';
import CollectionLink from '@react/react-spectrum/Icon/CollectionLink';
import Data from '@react/react-spectrum/Icon/Data';
import DataRefreshIcon from '@react/react-spectrum/Icon/DataRefresh';
import Devices from '@react/react-spectrum/Icon/Devices';
import DocumentFragment from '@react/react-spectrum/Icon/DocumentFragment';
import EmailIcon from '@react/react-spectrum/Icon/Email';
import ExperienceAddTo from '@react/react-spectrum/Icon/ExperienceAddTo';
import ExperienceIcon from '@react/react-spectrum/Icon/Experience';
import FileUser from '@react/react-spectrum/Icon/FileUser';
import FolderArchive from '@react/react-spectrum/Icon/FolderArchive';
import Gears from '@react/react-spectrum/Icon/Gears';
import GlobeGrid from '@react/react-spectrum/Icon/GlobeGrid';
import GraphTrend from '@react/react-spectrum/Icon/GraphTrend';
import Home from '@react/react-spectrum/Icon/Home';
import HomepageIcon from '@react/react-spectrum/Icon/Homepage';
import Key from '@react/react-spectrum/Icon/Key';
import Link from '@react/react-spectrum/Icon/Link';
import LinkPage from '@react/react-spectrum/Icon/LinkPage';
import Multiple from '@react/react-spectrum/Icon/Multiple';
import Offers from '@react/react-spectrum/Icon/Offer';
import Organisations from '@react/react-spectrum/Icon/Organisations';
import PageGear from '@react/react-spectrum/Icon/PageGear';
import Play from '@react/react-spectrum/Icon/Play';
import PlugIcon from '@react/react-spectrum/Icon/Plug';
import ProjectIcon from '@react/react-spectrum/Icon/Project';
import Promote from '@react/react-spectrum/Icon/Promote';
import Report from '@react/react-spectrum/Icon/Report';
import Send from '@react/react-spectrum/Icon/Send';
import ServersIcon from '@react/react-spectrum/Icon/Servers';
import Settings from '@react/react-spectrum/Icon/Settings';
import ShareAndroid from '@react/react-spectrum/Icon/ShareAndroid';
import Subscribe from '@react/react-spectrum/Icon/Subscribe';
import TrophyIcon from '@react/react-spectrum/Icon/Trophy';
import User from '@react/react-spectrum/Icon/User';
import UserAdmin from '@react/react-spectrum/Icon/UserAdmin';
import UserGroup from '@react/react-spectrum/Icon/UserGroup';
import Workflow from '@react/react-spectrum/Icon/Workflow';
import Wrench from '@react/react-spectrum/Icon/Wrench';
import UsersAdd from '@react/react-spectrum/Icon/UsersAdd';
import FileKey from '@react/react-spectrum/Icon/FileKey';
import PagesExclude from '@react/react-spectrum/Icon/PagesExclude';
import GearsEdit from '@react/react-spectrum/Icon/GearsEdit';

export const SIDE_NAV_FULL_ZOOM_WIDTH = 768;
export const sideNavMenu = [
  {
    label: 'Home',
    Icon: Home,
    to: '/'
  },
  {
    label: 'Settings',
    to: '/settings',
    Icon: GearsEdit,
    isAdmin: true,
    children: [
      {
        label: 'Account',
        Icon: UsersAdd,
        to: 'account'
      },
      {
        label: 'User Groups',
        Icon: UserGroup,
        to: 'group-management'
      },
      {
        label: 'Roles',
        Icon: UserAdmin,
        to: 'user-roles'
      },
      {
        label: 'Permissions',
        Icon: FileKey,
        to: 'user-permissions'
      },
      {
        label: 'API Resources',
        Icon: PagesExclude,
        to: 'api-resources'
      }
    ]
  }
];

export const sideNavIconMap = {
  App,
  BranchCircle,
  Campaign,
  Collection,
  CollectionLink,
  content: ArticleIcon,
  Data,
  datarefresh: DataRefreshIcon,
  Devices,
  DocumentFragment,
  email: EmailIcon,
  ExperienceAddTo,
  FileUser,
  FolderArchive,
  Gears,
  GlobeGrid,
  GraphTrend,
  Home,
  homepage: HomepageIcon,
  initiatives: ProjectIcon,
  Key,
  Link,
  LinkPage,
  Multiple,
  Offers,
  Organisations,
  PageGear,
  Play,
  playbook: ExperienceIcon,
  PlugIcon,
  Promote,
  Report,
  Send,
  servers: ServersIcon,
  Settings,
  ShareAndroid,
  Subscribe,
  trophy: TrophyIcon,
  User,
  UserAdmin,
  UserGroup,
  Workflow,
  Wrench
};
